import React, { useState, useEffect } from "react";
import "./videoIntro.css";
import headerLogo from "../../assets/logoJul.svg";

const VideoIntro = ({ onFinish }) => {
  const [showLogo, setShowLogo] = useState(false);
  const [animateLogo, setAnimateLogo] = useState(false);
  const videoSrc = "https://julcreative.com.tr/videos/jul2.mp4"; // Tam URL kullan

  useEffect(() => {
    const videoElement = document.querySelector(".intro-video");

    if (videoElement) {
      videoElement.addEventListener("error", () => {
        console.error("Video yüklenemedi veya desteklenmiyor.");
      });
    }
  }, []);

  const handleVideoEnd = () => {
    const videoElement = document.querySelector(".intro-video");
    if (videoElement) {
      videoElement.classList.add("fade-out"); // 2 saniyelik fade-out
    }

    // 100-300ms sonra secondHeader ve içerik gelsin
    setTimeout(() => {
      onFinish();
    }, 200); // Yani fade-out devam ederken secondHeader başlıyor
  };

  // const handleVideoEnd = () => {
  //   const videoElement = document.querySelector(".intro-video");
  //   if (videoElement) {
  //     videoElement.classList.add("fade-out");
  //   }

  //   setTimeout(() => {
  //     setShowLogo(true);
  //     setTimeout(() => {
  //       setAnimateLogo(true);
  //       setTimeout(onFinish, 1500);
  //     }, 700);
  //   }, 1500);
  // };

  return (
    <div className="video-intro">
      {!showLogo && (
        <video
          src={videoSrc} // Tam URL kullan
          autoPlay
          muted
          playsInline // iPhone uyumluluğu için
          onEnded={handleVideoEnd}
          className="intro-video"
        />
      )}

      {/* {showLogo && (
        <img
          src={headerLogo}
          alt="Header Logo"
          className={`intro-logo ${animateLogo ? "animate" : ""}`}
        />
      )} */}
    </div>
  );
};

export default VideoIntro;
